import ApplicationSchema from './Application.schema';
import { formatDate } from './UpdateApplication';

export const CREATE_APPLICATION = (application: ApplicationSchema) => {
  let mutation = `mutation {
        createApplication(input : {
          email: "${application.email}",`;
  if (application.buildingId) {
    mutation += `buildingId: "${application.buildingId}",`;
  } else if (application.buildingName) {
    mutation += `buildingName: "${application.buildingName}",`;
  } else if (application.address) {
    mutation += `address: {
            street: "${application.address.street}",
            shortNameStreet: "${application.address.shortNameStreet}",
            municipality:  "${application.address.municipality}",
            addressNumber:  "${application.address.addressNumber}",
            region: ${application.address.state},
            postalCode:  "${application.address.postalCode}",
        },`;
  }
  if (application.coverageStart) {
    mutation += `coverageStart:"${formatDate(application.coverageStart)}",`;
  }
  if (application.leaseEnd) {
    mutation += `leaseEnd:"${formatDate(application.leaseEnd)}",`;
  }

  mutation += `
        firstName: "${application.firstName}",
        lastName: "${application.lastName}",
        buildingUnit: "${application.buildingUnit}",
        phone: "${application.phone}",
    }){
        ... on ApplicationOutput {
            id,
            buildingId
        }
        ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
            }
        }
    }`;
  return mutation;
};
